import React, { createContext, useContext, useState } from 'react';

const TriggerContext = createContext();

export const useTrigger = () => (useContext(TriggerContext) || {}).trigger;

export const TriggerProvider = ({ children, triggerHandler }) => {
  const [trigger] = useState({ trigger: triggerHandler });
  return (
    <TriggerContext.Provider value={trigger}>
      {children}
    </TriggerContext.Provider>
  );
};
